import React from 'react';
import { BiSolidPhoneCall, BiLogoGmail } from 'react-icons/bi';
import { MdLocationOn } from 'react-icons/md';

export const HotelContactInfo = ({ data }) => {

    return (
        <div>
            <h3 className='mb-3'>Contact Info</h3>
            <h5>
                {data.names}
            </h5>
            {
                Array.isArray(data.phones) && !!(data.phones.length) &&
                <div
                    className='d-flex flew-row align-items-center my-3'
                >
                    <div
                        style={{
                            backgroundColor: '#e5f2ff',
                            borderRadius: '6px',
                            padding: '0.5rem',
                        }}
                    >
                        <BiSolidPhoneCall
                            style={{
                                fontSize: '2rem',
                                color: '#0081ff',
                            }}
                        />
                    </div>
                    <div
                        className='ms-3'
                    >
                        <p className='mb-0'
                            style={{
                                fontWeight: '500'
                            }}
                        >
                            Phone:
                        </p>
                        <div className='d-flex flex-row align-items-center flex-wrap'>
                            {
                                data.phones?.map(p => (
                                    <p
                                        key={p.phone}
                                        className='mb-0 me-2'
                                    >
                                        <a href={`tel:${p.phone}`} className='me-3'>{p.phone}</a>
                                    </p>
                                ))
                            }
                        </div>
                    </div>


                </div>
            }
            {
                Array.isArray(data.emails) && !!(data.emails.length) &&
                <div
                    className='d-flex flew-row align-items-center my-3'
                >
                    <div
                        style={{
                            backgroundColor: '#e5f2ff',
                            borderRadius: '6px',
                            padding: '0.5rem',
                        }}
                    >
                        <BiLogoGmail
                            style={{
                                fontSize: '2rem',
                                color: '#0081ff',
                            }}
                        />
                    </div>
                    <div
                        className='ms-3'
                    >
                        <p className='mb-0'
                            style={{
                                fontWeight: '500'
                            }}
                        >
                            Email:
                        </p>
                        <div className='d-flex flex-row align-items-center flex-wrap'>
                            {
                                data.emails?.map(p => (
                                    <p
                                        key={p.email}
                                        className='mb-0 me-2'
                                    >
                                        <a href={`mailto:${p.email}`} className='me-3'>{p.email}</a>
                                    </p>
                                ))
                            }
                        </div>
                    </div>
                </div>
            }
            <div
                className='d-flex flew-row align-items-center my-3'
            >
                <div
                    style={{
                        backgroundColor: '#e5f2ff',
                        borderRadius: '6px',
                        padding: '0.5rem',
                    }}
                >
                    <MdLocationOn
                        style={{
                            fontSize: '2rem',
                            color: '#0081ff',
                        }}
                    />
                </div>
                <div
                    className='ms-3'
                >
                    <p className='mb-0'
                        style={{
                            fontWeight: '500'
                        }}
                    >
                        Address:
                    </p>
                    <div className='d-flex flex-row align-items-center flex-wrap'>
                        <p
                            className='mb-0 me-2'
                        >
                            {data.addresses?.addressLines?.join(', ')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
